import LoadingIcon from "@/assets/images/icons/loading-primary.svg?inline";

export default {
  name: "tabs",

  data() {
    return {
      activeTab: this.currentTab,
    };
  },

  props: {
    tabHeaders: {
      type: Object,
      default: () => {}
    },
    currentTab: {
      default: 'all'
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      this.activeTab = this.currentTab;
    });
  },

  methods: {
    sortByStatus(type) {
      this.activeTab = type;
      this.$emit("changeResultsByStatus", type);
    }
  },

  components: {
    LoadingIcon
  }
};
